import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { GenericInputComponent } from '../generic-input/generic-input.component';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-login-terms',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    CommonModule
  ],
  templateUrl: './modal-login-terms.component.html',
  styleUrl: './modal-login-terms.component.scss'
})
export class ModalLoginTermsComponent implements OnInit {
  private fb = inject(FormBuilder);
  private dialog = inject(MatDialog);
  private dialogRef = inject(MatDialogRef);
  private authService = inject(AuthService);
  private router = inject(Router)
  user: any;
  form = this.fb.group({
    check: [false, Validators.required]
  })

  ngOnInit(): void {
    const userItem = sessionStorage.getItem('user');
    this.user = userItem ? JSON.parse(userItem) : {};
  }

  closeModal(confirm: boolean) {
    this.dialogRef.close(confirm);
  }

  submitForm(): void {
    const checked = this.form.get('check')?.value;
    this.form.markAllAsTouched();

    if (checked && this.form.valid) {
      this.authService.acceptDisclaimer().subscribe({
        next: (res: any) => {
          if (!this.user.confirmPersonalData) {
            this.router.navigate(['/client-panel/home']);
          } else {
            this.router.navigate(['/client-panel/consent-form']);
          }
          this.closeModal(true);
        },
        error: (error: any) => {
          this.dialog.open(ModalConfirmComponent, {
            data: {
              type: 'close-red',
              text: 'Erro ao registrar o aceite, por favor, tente novamente mais tarde.',
              hideCancelButton: 'true'
            }
          });
        }
      })
    }
  }
}
